import { COLORS } from '@btime/constants'
import { equals } from 'ramda'
import { useEffectAfterMount } from '@btime/react-hooks'
import React from 'react'

import { ControlledListHandler, useControlledList, useControlledListActions } from '@btime/react-contexts'
import FlexGrid from '../../../../../components/structure/FlexGrid'
import Draggable from '../../../../../components/dnd/Draggable'
import Droppable from '../../../../../components/dnd/Droppable'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import Icon from '../../../../../packages/kiti/components/shapes/Icon'
import Input from '../../../../../components/form/Input'
import Center from '../../../../../packages/kiti/components/helpers/Center'
import IconText from '../../../../../packages/kiti/components/presentation/IconText'
import Link from '../../../../../components/actions/Link'

const SelectFieldsOptions = ({ value, onChange, readOnly }) => {
  const list = useControlledList() || []
  const { setList, addNew, handleChangeItemValue, removeItem, moveItemCloseTo } = useControlledListActions()

  useEffectAfterMount(() => {
    if (!equals(value, list)) setList(value || [])
  }, [value])

  useEffectAfterMount(() => {
    if (!equals(value, list)) onChange(list)
  }, [list])

  const canRemove = list.length > 1 && !readOnly

  return (
    <FlexGrid direction="column" align="stretch" justify="flex-start" minHeight="auto">
      {list.map((item, index) => (
        <Draggable type="OPTION" item={item} hideOnDrag key={index}>
          <Droppable
            type="OPTION"
            onDrop={(fromItem, direction) => moveItemCloseTo(fromItem.reference, item.reference, direction)}
            placeholderWeight={8}
          >
            <Separator weight={1} />
            <FlexGrid gutter={0.2} key={item.reference}>
              <Icon name="BsArrowsMove" size="0.9rem" color={!readOnly && !!item.name ? COLORS.dark3 : COLORS.light3} />

              <Input xsmall onStopTyping={handleChangeItemValue(index, 'name')} value={item.name} readOnly={readOnly} />
              <Link block onClick={() => canRemove && !!item.name && removeItem(index)}>
                <Icon name="BsTrash" color={canRemove && !!item.name ? COLORS.red : COLORS.light3} size="0.9rem" />
              </Link>
            </FlexGrid>
            <Separator weight={1} />
          </Droppable>
        </Draggable>
      ))}
      <Separator weight={1} />
      {!readOnly && (
        <Center>
          <IconText
            iconName="BsPlusCircle"
            label="Add nova opção"
            size="small"
            left
            iconSize=".8rem"
            color={COLORS.purple}
            onClick={addNew}
          />
        </Center>
      )}
    </FlexGrid>
  )
}

const Wrapper = ({ value, type, ...props }) => {
  if (type !== 'select') return false

  return (
    <ControlledListHandler initialState={value || []} autoAdd>
      <SelectFieldsOptions value={value} {...props} />
    </ControlledListHandler>
  )
}

export default Wrapper
